import { Route } from '@angular/router';

import { profileEditingRestrictionGuard } from './guards/profile-editing-restriction.guard';

export const profileRoutes: Route[] = [
    {
        path: 'edit-profile',
        data: {
            hideTournamentNotification: true,
        },
        canActivate: [profileEditingRestrictionGuard],
        loadComponent: () => import('./pages/edit-profile/edit-profile.component').then((c) => c.EditProfileComponent),
    },
];
